import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAddons = (addons) => ({
  type: actionTypes.SET_ADDONS,
  payload: addons
})